interface AnswerOptionProps {
  id: string;
  text: string;
  label: string;
  isSelected: boolean;
  isCorrect?: boolean;
  isIncorrect?: boolean;
  showResult?: boolean;
  disabled?: boolean;
  onSelect: (id: string) => void;
}

export default function AnswerOption({
  id,
  text,
  label,
  isSelected,
  isCorrect,
  isIncorrect,
  showResult,
  disabled,
  onSelect,
}: AnswerOptionProps) {
  let borderClass = "border-gray-200 hover:border-primary-300 hover:bg-primary-50/50";
  let labelClass = "bg-gray-100 text-gray-700";

  if (isSelected && !showResult) {
    borderClass = "border-primary-500 bg-primary-50 ring-2 ring-primary-500/20";
    labelClass = "bg-primary-600 text-white";
  }

  if (showResult && isCorrect) {
    borderClass = "border-success-500 bg-success-50 ring-2 ring-success-500/20";
    labelClass = "bg-success-600 text-white";
  }

  if (showResult && isIncorrect && isSelected) {
    borderClass = "border-danger-500 bg-danger-50 ring-2 ring-danger-500/20";
    labelClass = "bg-danger-600 text-white";
  }

  return (
    <button
      type="button"
      onClick={() => !disabled && onSelect(id)}
      disabled={disabled}
      className={`flex w-full items-start space-x-3 rounded-lg border-2 p-4 text-left transition-all ${borderClass} ${disabled ? "cursor-default" : "cursor-pointer"}`}
    >
      <span
        className={`flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full text-sm font-bold ${labelClass} transition-colors`}
      >
        {label}
      </span>
      <span className="text-sm text-gray-800 pt-0.5">{text}</span>
      {showResult && isCorrect && (
        <svg className="ml-auto h-5 w-5 flex-shrink-0 text-success-600" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
        </svg>
      )}
      {showResult && isIncorrect && isSelected && (
        <svg className="ml-auto h-5 w-5 flex-shrink-0 text-danger-600" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
        </svg>
      )}
    </button>
  );
}
